import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SyllabusService } from 'src/app/_services/syllabus.service';
import { Proficiency } from '../../../../_models/proficiency';
import { SubTopic } from '../../../../_models/subTopic';

declare var $ : any;
@Component({
  selector: 'app-add-proficiency',
  templateUrl: './add-proficiency.component.html',
  styleUrls: ['./add-proficiency.component.css']
})

export class AddProficiencyComponent implements OnInit {
  @Input() subTopic =  new SubTopic()
  @Input() proficiency:Proficiency=new Proficiency()
  @Output()  addProficiencyFinished= new EventEmitter<number>()
  loading=false
  errorSaving=false
  isSaving=false
  myForm:FormGroup
  proficiencyTemp = new Proficiency()

  constructor(
    private syllabusService:SyllabusService
    ) {}

    get f(){
      return this.myForm.controls
    }
  ngOnInit(): void {
    this.proficiencyTemp.server_proficiency_id= this.proficiency.server_proficiency_id
    this.proficiencyTemp.server_subtopic_id = this.proficiency.server_subtopic_id
    this.proficiencyTemp.description = this.proficiency.description

    if(this.subTopic.server_subtopic_id!=0){

      this.myForm=new FormGroup({
        description: new FormControl(this.proficiencyTemp.description, [Validators.required,Validators.minLength(4)]),
        ordering: new FormControl(this.proficiencyTemp.ordering, [Validators.required])
      });
    }
    this.loading=true
    this.errorSaving=false
  }
  on_submit(){
    this.isSaving=true
    this.proficiencyTemp.description=this.myForm.value.description
    this.proficiencyTemp.ordering=this.myForm.value.ordering
    this.proficiencyTemp.server_subtopic_id=this.subTopic.server_subtopic_id
    this.proficiencyTemp.server_proficiency_id = this.proficiency.server_proficiency_id

    this.syllabusService.addEditProficiency(this.proficiencyTemp.formData()).subscribe(
      val=>{
        if(val['server_subtopic_id']==0){
          this.errorSaving=true
        }
        else{
          this.subTopic=val
          this.loading=false
          this.closeAddProficiencyModal(this.proficiencyTemp.server_proficiency_id)
        }
        this.isSaving=false
      }
    )
  }

  closeAddProficiencyModal(modelId:number){
    this.addProficiencyFinished.emit(modelId)
  }
}
